import { MdcSnackbar } from '@angular-mdc/web';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { Router , NavigationExtras} from '@angular/router';
import { ModalFiltroTagsComponent } from '../componentes/modal-filtro-tags/modal-filtro-tags.component';
import { ModalDescargarProductosExcelComponent } from '../modal-descargar-productos-excel/modal-descargar-productos-excel.component';
import { Globals } from '../globals';
import { ProductoService } from '../servicios/producto.service';
@Component({
  selector: 'app-menu-nuevo',
  templateUrl: './menu-nuevo.component.html',
  styleUrls: ['./menu-nuevo.component.scss']
})
export class MenuNuevoComponent implements OnInit {
  isListExpanded = false;
  expanded: boolean = false;
  registros = [];

  tagsField = "";

  tags = {
    cargando: false,
    registros: new Array()
  };
  progress:string = '';
  constructor(
		private router: Router,
    public globals: Globals,
    private productoService: ProductoService,
    private dialog: MatDialog
  ) { }
  tomarTag(tagId, modelo){
    console.log(tagId,modelo);
		this.globals.configuracion.front.listado.tag = tagId;
		this.globals.configuracion.front.listado.tag_descripcion = modelo;

    // Crear un objeto con los parámetros que deseas pasar
    const parametros = {
      tag: tagId,
      tag_descripcion: modelo,
      buscar:true,
      pagina:1
    };

    // Crear un objeto de tipo NavigationExtras y asignar los parámetros
    const navigationExtras: NavigationExtras = {
      queryParams: parametros,
    };

    this.router.navigate([`/catalogo`],navigationExtras);
		// this.search();
    // this.snackBar.open(`La categoría ${modelo} ha sido seleccionada`, 'Cerrar');

    // this.navegarACatalogo();
  }
  openModal(): void {
    const dialogRef = this.dialog.open(ModalDescargarProductosExcelComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log('Modal cerrada, resultado:', result);
    });
  }
  


  obtenerRegistrosPaginados() {
    this.openModal();
    
  }
 
  aceptarTags(){
    let modeloSelect = {
      idmodelo: "",
      marca_modelo: ""
    }
    if( this.tagsField != '' ){
      let itemSearch = this.tags.registros.find( tag => tag.idmodelo == this.tagsField );
      if( itemSearch != undefined ){
        modeloSelect.idmodelo = itemSearch.idmodelo;
        modeloSelect.marca_modelo = itemSearch.marca_modelo;
      }
    }
    // this.dialogRef.close( modeloSelect );
  }
  cargarTags(){
    this.productoService.tagsListado({
      categoria: this.globals.configuracion.front.listado.categoria
    }).subscribe(
      resultado =>{
        if( !resultado.error ){
          Array.prototype.push.apply( this.tags.registros, resultado.registros );
          this.tags.cargando = false;
        }else{
          console.log("Error",resultado.mensaje);
        }

      },
      error =>{
        console.log("Error",error);
        //this.feedProductos.cargando = false;
      }
    )
  }
  toggleExpand() {
    
    this.expanded = !this.expanded;
    console.log(this.expanded);
  }
  ngOnInit(): void {
    console.log('globals categoria',this.globals.configuracion.front.listado.categoria)
    this.tagsField = this.globals.configuracion.front.listado.tag;
    this.cargarTags();
    if(!this.globals.configuracion.front.listado.categoria){
      
      this.router.navigate(['/']);
    }
  }
  navegarACatalogo(ordenar = null, ordenar_modo = null){
    if(ordenar && ordenar_modo){
      
      // this.formSearch.controls.busqueda.setValue("");
      this.globals.configuracion.front.listado.tag = "";
      this.globals.configuracion.front.listado.tag_descripcion = "";
  
      this.globals.configuracion.front.listado.ordenar_new = ordenar;
      this.globals.configuracion.front.listado.ordenar_modo = ordenar_modo;

      // Crear un objeto con los parámetros que deseas pasar
      const parametros = {
        ordenar_new: ordenar,
        ordenar_modo: ordenar_modo,
      };

      // Crear un objeto de tipo NavigationExtras y asignar los parámetros
      const navigationExtras: NavigationExtras = {
        queryParams: parametros,
      };
    
      this.router.navigate([`/catalogo`],navigationExtras);

    }else{

      this.router.navigate([`/catalogo`]);
    }

  }
  navegarACotizaciones(){
    this.router.navigate(['/cotizaciones']);

  }
  toggleList() {
    this.isListExpanded = !this.isListExpanded;
  }
  
}
